import React from 'react';
import PropTypes from 'prop-types';
import Card from '../../components/Card';
import OptionStacked from '../../pages/my-network/OptionStacked';
import { DocumentTextIcon } from '@heroicons/react/24/outline';

FeaturedResource.propTypes = {
  supportQuestion: PropTypes.object.isRequired
};

export default function FeaturedResource(props) {
  const { supportQuestion } = props;

  return (
    <Card className="overflow-hidden">
      <OptionStacked
        icon={DocumentTextIcon}
        title={supportQuestion.data.resourceTitle}
        subtitle={supportQuestion.data.resourceDescription}
        linkText="View resource"
        link={supportQuestion.data.resourceUrl}
      />
    </Card>
  );
};
